import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import { useActivityTagsState, useMutation, useQuery, useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { EligibilityCriteria } from './EligibilityCriteria'
import { useToast } from '@percent/admin-dashboard/containers/toast/ToastContext'
import { APIErrorHandler } from '@percent/admin-dashboard/common/library/APIErrorHandler'

export function EligibilityCriteriaContainer() {
  const toast = useToast()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { validationSubmissionsService } = useServices()
  const { configurationId } = useRequiredParams()

  const [{ isLoading: isUpdatingEligibilityCriteria }, { apiFunc: updateEligibilityCriteria }] = useMutation(
    validationSubmissionsService.updateValidationSubmissionSubTags,
    () => {
      toast(t('toast.updateEligibilityCriteriaSuccess'), 'success')
      navigate(-1)
    },
    error => {
      if (axios.isAxiosError(error)) {
        toast(APIErrorHandler(error?.response?.data?.error), 'error')
      }
    }
  )

  const [
    {
      data: validationSubmissionConfig,
      isLoading: isLoadingValidationSubmissionConfig,
      errorMessage: validationSubmissionConfigErrorMessage
    }
  ] = useQuery(validationSubmissionsService.getValidationSubmissionConfiguration, {
    id: configurationId
  })

  const {
    activityTags: tagsData,
    isLoading: isLoadingActivityTags,
    errorMessage: activityTagsErrorMessage
  } = useActivityTagsState()

  const isLoading = isLoadingValidationSubmissionConfig || isLoadingActivityTags
  const errorMessage = validationSubmissionConfigErrorMessage || activityTagsErrorMessage

  const performSaveEligibilityCriteria = async (subTags: string[]) => {
    await updateEligibilityCriteria({ id: configurationId, subtags: subTags })
  }

  return (
    <EligibilityCriteria
      program={validationSubmissionConfig}
      activityTags={tagsData}
      isLoading={isLoading}
      errorMessage={errorMessage}
      onSaveEligibilityCriteria={performSaveEligibilityCriteria}
      isSaving={isUpdatingEligibilityCriteria}
    />
  )
}
